export default __webpack_public_path__ + "static/media/group1.5a9089a2.png";